module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_4.5d11812a.png";